/**
 * Cheeky Frog — copyable discount codes in the announcement bar
 *
 * A discount code you cannot copy is a code most people will not use: they are
 * on a phone, the bar is 12px tall, and selecting text inside a moving carousel
 * is a genuinely hard thing to do. This turns the code itself into a button.
 *
 * The code is found by pattern rather than by markup, because the announcement
 * text is a plain-text theme setting that Liquid escapes — there is nowhere to
 * put a class. Anything that looks like a code (all caps, letters then digits,
 * six characters or more) becomes clickable, so adding a fifth offer in the
 * theme editor needs no code change here.
 */
(function () {
  'use strict';

  // FROGGIE15, CHEEKYWOW30 — caps and digits, at least 6 long, digits at the
  // end. Deliberately narrow: it must not match a shouted ordinary word.
  var CODE = /\b[A-Z][A-Z]{4,}[0-9]{1,3}\b/g;
  var RESET_MS = 2000;

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Safari on http, and older browsers, have no clipboard API.
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:absolute;left:-9999px;top:0;';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy') ? resolve() : reject(); }
      catch (e) { reject(e); }
      finally { document.body.removeChild(ta); }
    });
  }

  function decorate(span) {
    var text = span.textContent;
    if (!CODE.test(text)) return;
    CODE.lastIndex = 0;

    var frag = document.createDocumentFragment();
    var last = 0, m;
    while ((m = CODE.exec(text)) !== null) {
      if (m.index > last) {
        frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cf-code';
      b.dataset.code = m[0];
      b.textContent = m[0];
      b.setAttribute('aria-label', 'Copy discount code ' + m[0]);
      frag.appendChild(b);
      last = m.index + m[0].length;
    }
    if (last < text.length) {
      frag.appendChild(document.createTextNode(text.slice(last)));
    }
    span.textContent = '';
    span.appendChild(frag);
  }

  function init() {
    document.querySelectorAll('.announcement-bar__message span')
      .forEach(decorate);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cf-code');
    if (!btn) return;
    e.preventDefault();
    // The slide may be wrapped in a link to the shop; copying is the more
    // specific intent, so it wins and the navigation is suppressed above.
    e.stopPropagation();
    var code = btn.dataset.code;
    copy(code).then(function () {
      if (btn.dataset.busy) return;
      btn.dataset.busy = '1';
      var was = btn.textContent;
      btn.textContent = 'Copied ✓';
      btn.classList.add('is-copied');
      setTimeout(function () {
        btn.textContent = was;
        btn.classList.remove('is-copied');
        delete btn.dataset.busy;
      }, RESET_MS);
    }).catch(function () { /* leave the code on screen to select by hand */ });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
